import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'floorPointSize',
  pure: true, // ensures it only recalculates when input changes
})
export class FloorPointSizePipe implements PipeTransform {
  transform(
    pointCoord: number,
    isVideo: boolean,
    displaySize: number,
    realSize: number,
    ratio: number,
    direction: 'x' | 'y',
  ): string {
    if (
      pointCoord == null ||
      displaySize == null ||
      realSize == null ||
      ratio == null ||
      !['x', 'y'].includes(direction)
    ) {
      return '0px';
    }

    const base = (pointCoord * displaySize) / realSize;
    const offsetRaw = ((25 / 2) * displaySize) / realSize;
    const offset = isVideo ? offsetRaw : offsetRaw * 1.3;
    const adjusted = (base - offset) * ratio;

    return `${adjusted.toFixed(0)}px`;
  }
}
